import { ReactChild } from 'react';
import { useHistory } from 'react-router-dom';
import { AppBar, Button, Grid, Toolbar } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Footer from 'layouts/common/footer';

const useStyles = makeStyles(() => ({
  container: { minHeight: '100vh', display: 'flex', flexDirection: 'column' },
  toolbar: {
    minHeight: 150,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    width: '75%',
    backgroundColor: 'white',
  },
  button: {
    background: '#F5DE76',
    paddingTop: '5px',
    paddingLeft: '15px',
    paddingRight: '15px',
    width: '120px',
    height: '40px',
  },
}));

type Props = {
  children: ReactChild;
  hideFooterOnMobile?: boolean;
};

export default function NotAuthLayout({ children, hideFooterOnMobile = false }: Props) {
  const history = useHistory();
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div>
        <AppBar position="static">
          <Toolbar className={classes.toolbar}>
            <Grid container direction="row" justifyContent="flex-start" alignItems="center">
              <Grid item xs={12}>
                <img src="/header-logo.svg" alt="header-logo" />
              </Grid>
            </Grid>
            <Button className={classes.button} onClick={() => history.push('/')}>
              Sign in
            </Button>
          </Toolbar>
        </AppBar>
      </div>
      {children}
      <Footer hideOnMobile={hideFooterOnMobile} />
    </div>
  );
}
